/* eslint-disable */
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI table and other components
import { MaterialReactTable } from "material-react-table";
import { MenuItem, Box } from "@mui/material";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { assetImages } from "constants";

import GroupListHeader from "../Header/GroupListHeader";

import AddLabelModal from "components/Common/Modal/AddLabelModal";
import GroupListFilterPopup from "../Popup/GroupListFilterPopup";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import { createGroupChatHandler } from "helper/GroupHelper/GroupHelper";
import { replaceListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import AddFollowerModal from "components/Common/Modal/AddFollowerModal";

const GroupListBody = () => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const { t, i18n } = useTranslation(); //for translation

  const [isLoading, setIsLoading] = useState(false);
  const [groupList, setGroupList] = useState([]);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedGroupIds, setSelectedGroupIds] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //filter requirements
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]); // json filter query
  const [reloadData, setReloadData] = useState(false); // reload data
  const [isFilterReset, setIsFilterReset] = useState(false); // filter reset

  //function for get all group records
  const getAllGroups = async () => {
    setRowSelection({});
    setSelectedGroupIds([]);
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_GROUPS +
        `?token=${token}&modulefrom=backend`;

      console.log("url of group list---------->", requestUrl);

      const response = await getData(requestUrl);

      console.log("response in group list------->", response);

      setIsLoading(false);
      if (response.status) {
        setGroupList(response.data);
        setMessageType("success");
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }
    setShowAlert(true);
  };

  const getFilteredGroups = async () => {
    try {
      setIsLoading(true);

      // console.log("Original jsonFilterQuery:", jsonFilterQuery);

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      // console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };

      // console.log("filter data------->", filterData);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_FILTERED_GROUPS +
        `?token=${token}&modulefrom=backend`;

      console.log("url of group list---------->", requestUrl);

      const response = await postData(requestUrl, filterData);

      console.log("response in group list------->", response);

      setIsLoading(false);
      if (response.status) {
        setGroupList(response.data);
        setMessageType("success");
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for change rank
  const rankInputChangeHandler = (row, value) => {
    const updatedGroupList = [...groupList];

    const rowIndex = updatedGroupList.findIndex(
      (group) => group._id === row.original._id
    );

    if (rowIndex !== -1) {
      updatedGroupList[rowIndex].rank = value;
      setGroupList(updatedGroupList);
    }
  };

  //function for update rank
  const updateRankHandler = async () => {
    if (selectedGroupIds.length > 0) {
      try {
        const groupListToBeUpdate = groupList.filter((item) =>
          selectedGroupIds.includes(item._id)
        );

        let groupData = {
          grouplist: groupListToBeUpdate,
        };

        let requestURL =
          url.API_BASE_URL + url.API_UPDATE_BULK_GROUP + `?token=${token}`;

        const response = await putData(requestURL, groupData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setSelectedGroupIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select atleast one group");
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //function for change status
  const deleteBulkGroupHandler = async (e) => {
    if (selectedGroupIds.length > 0) {
      try {
        const groupListToBeDelete = groupList.filter((item) =>
          selectedGroupIds.includes(item._id)
        );

        let groupData = {
          grouplist: groupListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL + url.API_DELETE_BULK_GROUP + `?token=${token}`;

        const response = await putData(requestURL, groupData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setGroupList((prev) =>
              prev.filter((item) => !selectedGroupIds.includes(item._id))
            );
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select atleast one group");
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //function for remove tag from group
  const removeTagFromGroup = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_GROUP; // Assuming a similar API endpoint for events
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedGroupId(null);
      }, 1000);
    }
  };

  //function for after modal close
  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setGroupList((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  //function for reset filter
  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  //use effect for search filter popup
  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getFilteredGroups();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllGroups();
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    getAllGroups();
  }, []);

  /*
   * Material React Table Column and States -----------------------------------------------------------
   *---------------------------------------------------------------------------------------------------
   */
  const columns = useMemo(
    () => [
      {
        accessorKey: "title",
        header: t("Title"),
        size: 250,
        Cell: ({ row }) => {
          return (
            <div className="d-flex justify-content-between gap-2">
              <p>{row.original.title}</p>
              <button
                onClick={() => {
                  createGroupChatHandler(row.original._id);
                }}
                className={
                  row.original.moderator.toString() ===
                    userInfo._id.toString() ||
                  row.original.groupmembers?.includes(userInfo._id)
                    ? "d-flex align-items-center ms-auto border-0 bg-light"
                    : "d-none"
                }
              >
                <span className="d-block material-symbols-outlined icon-md text-primary">
                  chat
                </span>
              </button>
            </div>
          );
        },
      },
      {
        accessorKey: "tagstring",
        header: t("Tags"),
        size: 200,
        Cell: ({ row }) => (
          <div className="label-wrapper py-1">
            <div className="d-flex gap-2">
              <div
                className={
                  row.original.taglist.length > 0
                    ? "label-container flex-grow-1"
                    : "d-none"
                }
              >
                <ul
                  className="d-flex flex-wrap gap-2 m-0 p-0"
                  style={{ listStyle: "none" }}
                >
                  {row.original.taglist.map((tag, index) => (
                    <li key={index} className="d-inline-flex">
                      <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                        <span className="badge-text fs-xs fw-medium me-1">
                          {tag.title}
                        </span>
                        <Link
                          to="#"
                          className={`${
                            tag.moderator.toString() ===
                              userInfo._id.toString() ||
                            userInfo.role.slug === "ADMIN" ||
                            userInfo.role.slug === "SUPER_ADMIN"
                              ? "d-block"
                              : "d-none"
                          }`}
                          onClick={() => {
                            setSelectedGroupId(row.original._id);
                            setSelectedTagId(tag._id);
                            removeTagFromGroup([tag._id], row.original._id);
                          }}
                        >
                          {selectedTagId &&
                          selectedTagId === tag._id &&
                          selectedGroupId &&
                          selectedGroupId === row.original._id ? (
                            <div
                              className="spinner-border spinner-border-sm text-primary ms-1"
                              role="status"
                              style={{ height: "12px", width: "12px" }}
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <span
                              className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                              style={{ cursor: "pointer" }}
                            >
                              cancel
                            </span>
                          )}
                        </Link>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <button
                className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
                style={{ width: "24px", height: "24px" }}
                data-bs-toggle="modal"
                data-bs-target="#addLabelModal"
                onClick={() => setSelectedGroupIds([row.original._id])}
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "16px" }}
                >
                  add
                </span>
              </button>
            </div>
          </div>
        ),
      },
      {
        accessorKey: "groupmembercount",
        header: t("Members"),
        size: 50,
      },
      {
        accessorKey: "rank",
        header: t("Rank"),
        size: 100,
        Cell: ({ row }) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              width: "100px",
            }}
          >
            <input
              type="number"
              name="rank"
              id="rank"
              value={row.original.rank}
              onChange={(e) => rankInputChangeHandler(row, e.target.value)}
              className="form-control fs-sm text-gray bg-white py-2 border-gray-300 shadow-none"
            />
          </Box>
        ),
      },
      {
        accessorKey: "moderatorname",
        header: t("Moderator"),
        size: 200,
        Cell: ({ row }) => (
          <div className="moderator border-bottom-0">
            <div className="d-flex align-items-center gap-2">
              <div
                className="avatar rounded-circle overflow-hidden"
                style={{ width: "25px", height: "25px" }}
              >
                <img
                  src={
                    row.original.moderatorimage == ""
                      ? assetImages.defaultUser
                      : url.SERVER_URL + row.original.moderatorimage
                  }
                  alt="Richard Hawail"
                  className="w-100 h-100 object-fit-cover object-center"
                />
              </div>
              <p>{row.original.moderatorname}</p>
            </div>
          </div>
        ),
      },
      //follower
      {
        accessorKey: "followersnames",
        header: t("Followers"),
        size: 250,
        Cell: ({ row }) =>
          row.original.followerslist.map((follower, index) => (
            <div
              className="owner border-bottom-0 d-flex gap-1 mb-1"
              key={index}
            >
              <img
                className="rounded-circle"
                height={15}
                width={15}
                src={
                  follower.image == ""
                    ? assetImages.defaultUser
                    : url.SERVER_URL + follower.image
                }
                alt="Babcock"
              />

              <p>
                <span className="d-block">{follower.fullname}</span>
              </p>
              {/* <button
                onClick={() => {
                  createContactChatHandler(row.original._id);
                }}
                className={
                  follower._id === userInfo._id
                    ? "d-none"
                    : "d-flex align-items-center ms-auto border-0 bg-light"
                }
              >
                <span className="d-block material-symbols-outlined icon-md text-primary">
                  chat
                </span>
              </button> */}
            </div>
          )),
      },
      {
        accessorKey: "grouptype",
        header: t("Type"),
      },
      {
        accessorKey: "categorystring",
        header: t("Category"),
        size: 150,
      },
      {
        accessorKey: "groupcreateddate",
        header: t("Date"),
      },
    ],
    [groupList, selectedTagId, selectedGroupId, i18n.language]
  );

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    if (selectedIdsArray.length > 0) {
      setSelectedGroupIds(selectedIdsArray);
    } else {
      setSelectedGroupIds([]);
    }
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_GROUP")
  ) {
    return (
      <div id="content_wrapper">
        <section className="survey-wrapper bg-white pb-5">
          <div className="container-fluid px-lg-5">
            {/* --- group list filter --- */}
            <GroupListHeader
              reloadList={resetFilterData}
              updateRankHandler={updateRankHandler}
              selectedGroupIds={selectedGroupIds}
              jsonFilterQuery={jsonFilterQuery}
            />

            {isLoading ? (
              <div className="placeholder-glow d-flex flex-column gap-4">
                <span className="placeholder placeholder-lg bg-secondary col-12"></span>
                <span className="placeholder placeholder-lg bg-secondary col-8"></span>
                <span className="placeholder placeholder-lg bg-secondary col-4"></span>
              </div>
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={groupList} // data from api to be displayed
                  enableGrouping
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => row._id} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{ rowSelection }} //pass our managed row selection state to the table to use
                  enableRowActions // show the action column
                  renderRowActionMenuItems={({ row }) => [
                    <MenuItem
                      key="edit"
                      //onClick={() => console.info(row.id)}
                    >
                      <Link
                        className="dropdown-item"
                        to={`/admin/group/info/${row.id}`}
                      >
                        {t("View Details")}
                      </Link>
                    </MenuItem>,
                    <MenuItem
                      key="members"
                      //onClick={() => console.info(row.id)}
                    >
                      <Link
                        className="dropdown-item"
                        to={`/admin/group/members/${row.id}`}
                      >
                        {t("View Members")}
                      </Link>
                    </MenuItem>,
                    <MenuItem
                      key="partner"
                      //onClick={() => console.info(row.id)}
                    >
                      <Link
                        className="dropdown-item"
                        to={`/admin/group/grouppartner/${row.id}`}
                      >
                        {t("View Partners")}
                      </Link>
                    </MenuItem>,
                    <MenuItem
                      key="gallery"
                      //onClick={() => console.info(row.id)}
                    >
                      <Link
                        className="dropdown-item"
                        to={`/admin/group/gallery/${row.id}`}
                      >
                        {t("View Gallery")}
                      </Link>
                    </MenuItem>,
                  ]} // action columns menu items
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
        </section>

        {/* ==== modals and popup area === */}
        {/* --- add lable modal --- */}
        <AddLabelModal
          moduleName="group"
          selectedIds={selectedGroupIds}
          afterTagModalClose={afterModalActionClose}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          onModalClose={() => {
            setSelectedGroupIds([]);
            setRowSelection({});
          }}
        />

        {/* --- filter popup --- */}
        {/* <FilterPopup /> */}
        <GroupListFilterPopup
          setJsonFilterQuery={setJsonFilterQuery}
          reloadList={resetFilterData}
          moduleSlug="grouplist"
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
        />

        <AddFollowerModal
          moduleName="grouplist"
          selectedIds={selectedGroupIds}
          afterModalClose={afterModalActionClose}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          onModalClose={() => {
            setSelectedGroupIds([]);
            setRowSelection({});
          }}
        />

        {/* ----------- delete warning modal ------------ */}
        <DeleteWarningModal
          onCancelDelete={() => {
            setRowSelection({});
            setSelectedGroupIds([]);
          }}
          onDelete={deleteBulkGroupHandler}
          moduleName={t("group")}
        />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default GroupListBody;
